import React, { useState, useEffect } from 'react';
import {
    Box,
    Button,
    Card,
    CardContent,
    Typography,
    Grid,
    Avatar,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import Badge from '@mui/material/Badge';
import MarkEmailUnreadIcon from '@mui/icons-material/MarkEmailUnread';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../lib/axios';
import { toast } from 'react-toastify';
import CallIcon from '@mui/icons-material/Call';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const ServiceProUserProfile = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [cancel, setCancel] = useState(false);
    const navigate = useNavigate();
    const [profileData, setProfileData] = useState({
        ServiceProvider: '',
        MobileNo: '',
        Email: '',
        Address: ''
    });
    const [ticketCounts, setTicketCounts] = useState({
        open: 0,
        closed: 0,
        resolved: 0,
    });

    const handleBack = () => {
        navigate("/serviceprov-dash");
    };

    useEffect(() => {
        const fetchTicketStatus = async () => {
            try {
                const response = await axiosInstance.post("TrnTicketing/GetTrnTicketDashBoard",
                    {
                        start: 0,
                        PageSize: 0,
                        SearchText: ""
                    }
                );
                if (response.data.Status === 0 && Array.isArray(response.data.Data)) {
                    const data = response.data.Data;
                    const counts = {
                        open: data.filter(ticket => ticket.TicketSt === 'O').length,
                        resolved: data.filter(ticket => ticket.TicketSt === 'R').length,
                        closed: data.filter(ticket => ticket.TicketSt === 'C').length,
                    };
                    setTicketCounts(counts);
                    if (data.length > 0) {
                        const firstTicket = data[0];
                        setProfileData({
                            ServiceProvider: firstTicket.ServiceProvider || '',
                            Email: firstTicket.Email || '',
                            MobileNo: firstTicket.MobileNo || '',
                        });
                    }
                }
            } catch (error) {
                toast.error("Error while fetching the status");
            }
        };
        fetchTicketStatus();
    }, [])

    return (
        <Box sx={{ p: 3 }}>
            <Card
                sx={{
                    maxWidth: 900,
                    mx: 'auto',
                    p: 3,
                    display: { xs: "flex", sm: "none", md: 'none' },
                    flexDirection: 'column',
                    gap: 3,
                    boxShadow: 3,
                    borderRadius: 3,
                    position: 'relative',
                    mb: '60px',
                }}
            >
                <Box
                    sx={{
                        position: { xs: 'static', md: 'absolute' },
                        top: { md: 16 },
                        right: { md: 16 },
                        display: 'flex',
                        justifyContent: { xs: 'center', md: 'flex-end' },
                        flexWrap: 'wrap',
                        gap: 3,
                        mt: { xs: 2, md: 0 }, // margin top only for mobile
                    }}
                >
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Badge badgeContent={ticketCounts.open} color="warning">
                            <MarkEmailUnreadIcon color="warning" />
                        </Badge>
                        <Typography variant="caption">Accepted</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Badge badgeContent={ticketCounts.resolved} color="success">
                            <CheckCircleIcon color="success" />
                        </Badge>
                        <Typography variant="caption">Resolved</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Badge badgeContent={ticketCounts.closed} color="error">
                            <CancelIcon color="error" />
                        </Badge>
                        <Typography variant="caption">Closed</Typography>
                    </Box>
                </Box>

                <Box sx={{
                    textAlign: 'center',
                    background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                }}>
                    <Typography variant="h6" fontWeight="bold">
                        Profile Overview
                    </Typography>
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: isMobile ? 'column' : 'row',
                        alignItems: isMobile ? 'center' : 'flex-start',
                        gap: 3,
                    }}
                >
                    <Avatar
                        alt="Service Provider"
                        src="https://cdn1.iconfinder.com/data/icons/user-pictures/101/malecostume-512.png"
                        sx={{
                            width: 120,
                            height: 120,
                            border: '1px solid #1976d2'
                        }}
                    />
                    <CardContent sx={{ flex: 1, px: 0, pt: 0, pb: '0 !important' }}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="h6">{profileData.ServiceProvider}</Typography>
                                <Typography>Electrician</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                    <EmailIcon color='success' sx={{ mr: 1, color: 'text.secondary' }} />
                                    <Typography>{profileData.Email || 'service@gmail.com'}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center' , mb: 1 }}>
                                    <CallIcon sx={{ mr: 1, color: 'text.secondary' }} />
                                    <Typography>{profileData.MobileNo}</Typography>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <LocationOnIcon sx={{ mr: 1, color: 'text.secondary' }} />
                                    <Typography>{profileData.Address}</Typography>
                                </Box>
                            </Grid>
                            {/* <Grid item xs={12}>
                                <Typography variant="body1" sx={{ mt: 1 }}>
                                     Experienced service provider specializing in electrical installations and repairs. 
                                </Typography>
                            </Grid> */}
                        </Grid>
                        {/* <Box sx={{ mt: 2, display: 'flex', gap: 1, justifyContent: isMobile ? 'center' : 'flex-end' }}>
                            <Button
                                variant="outlined"
                                startIcon={!cancel ? <EditIcon /> : null}
                                sx={{ borderRadius: '9px' }}
                                onClick={() => setCancel((prev) => !prev)}
                            >
                                {cancel ? 'cancel' : 'edit'}
                            </Button>

                            <Button
                                variant='outlined'
                                onClick={handleBack}
                                color='error'
                                sx={{ borderRadius: '9px' }}
                            >
                                Back
                            </Button>
                        </Box> */}
                    </CardContent>
                </Box>
            </Card >
        </Box >
    );
};

export default ServiceProUserProfile;